import { RefCounted } from 'neuroglancer/util/disposable';
import { removeFromParent } from 'neuroglancer/util/dom';
import { makeElementUtil } from '../util/http_request';
import './message.less';
import svg_success from '../../static/success.svg';
import svg_error from '../../static/error.svg';
import svg_info from '../../static/info.svg';
import svg_warning from '../../static/warning.svg';

const iconPath = [
    {type: 'success', path:svg_success, color: '#67c23a', background: '#f0f9eb', borderColor: '#e1f3d8'},
    {type: 'info', path: svg_info, color: '#909399', background: '#edf2fc', borderColor: '#ebeef5'},
    {type: 'warning', path: svg_warning, color: '#e6a23c', background: '#fdf6ec', borderColor: '#faecd8'},
    {type: 'error', path: svg_error, color: '#f56c6c', background: '#fef0f0', borderColor: '#fde2e2'}
]

export class message extends RefCounted {
    list:HTMLElement|null = document.getElementById('message-list')
    element = makeElementUtil('li', ['message_box_outside','fade-in']);
    inner = makeElementUtil('div', ['message_box_inside']);
    close = makeElementUtil('p',['question-close'],{'style': 'top: 0.375rem;right: 0.5rem;color: #fff;'},`X`);
    constructor(message:string | string[], type:string, flag?: boolean) {
        super();
        if(!this.list) {
            this.list = document.createElement('ul');
            this.list.setAttribute('id', 'message-list')
        }
        const { element, inner, close } = this;
        const iconInfo = this.showIcon(type);
        const icon = makeElementUtil('div', ['message-icon'], {}, iconInfo.path);
        let messageInfo:HTMLElement = makeElementUtil('div', ['message-info'], {}, '');
        if (typeof message === 'string') {
          messageInfo.innerHTML = message;
        } else {
          let messageInfoDomStr = '';
          message.forEach(item=>{
            messageInfoDomStr += `<p>${item}</p>`
          })
          messageInfo.innerHTML = messageInfoDomStr;
        }
        inner.appendChild(icon);
        inner.appendChild(messageInfo);
        element.appendChild(inner);
        this.list.appendChild(element);
        document.body.appendChild(this.list);
        if(flag){
            inner.style.position = 'relative';
            inner.style.padding = '1rem';
            inner.appendChild(close);
            element.classList.add('message-box-close');
            close.addEventListener('click',()=>{
                removeFromParent(element)
            })
        }else{
            this.showMessage();
        }
    }
    closed(){
        removeFromParent(this.element)
    }
    showMessage(){
        // 防止多次闪动     
        setTimeout(()=>{
            this.element.classList.remove('fade-in');
        },3000)
        setTimeout(() => {
            this.element.classList.add('fade-out');
            this.element.addEventListener('animationend', function () {
                removeFromParent(this)
            });
        }, 5000);
    }
    showIcon(type: string){
        for(let i = 0; i < iconPath.length; i++){
            if(iconPath[i].type === type){
                return iconPath[i];
            }
        }
        return iconPath[1];
    }
}
